module.exports = __webpack_public_path__ + "img/sgs.f47f701c.svg";